import { c as _c } from "react/compiler-runtime";
import type { IconProps } from './Icon.types';
import { IconWrapper } from './IconWrapper';
const HandCard = t0 => {
  const $ = _c(8);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M11 9L22 9" strokeLinecap="round" strokeLinejoin="round" />;
    t2 = <path d="M2 11L4.80662 7.84255C5.5657 6.98859 6.65372 6.5 7.79627 6.5L8 6.5" strokeLinecap="round" strokeLinejoin="round" />;
    t3 = <path d="M2 19.5003L7.5 19.5L11.5 16.5003C11.5 16.5003 12.3091 15.9528 13.5 15.0001C16 13.0002 13.5 9.83352 11 11.4997C8.96409 12.8565 7 14.0003 7 14.0003" strokeLinecap="round" strokeLinejoin="round" />;
    t4 = <path d="M8 13.5V7C8 5.89543 8.89543 5 10 5H20C21.1046 5 22 5.89543 22 7V13C22 14.1046 21.1046 15 20 15H13.5" />;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[6] !== props) {
    t5 = <IconWrapper {...props} variant="outline">{t1}{t2}{t3}{t4}</IconWrapper>;
    $[6] = props;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
};
export { HandCard };